import axios from 'axios';

export const updateAccountInfo = formData => {
  const { firstName, lastName, email, phone } = formData;
  return axios.put('/account/info', {
    firstName,
    lastName,
    email,
    phoneNumber: phone,
  });
};
